// extracted by css-extract-rspack-plugin
export default {"history":"yb8Q0"};